export const onboardingRouteName = 'OnboardingRoute' as const

const routes = [
  // Support Center token
  {
    name: 'SupportRoute',
    path: '/me/support',
    component: () =>
      import('src/components/Auth/ZendeskSSOAuth/ZendeskSSOAuth.vue'),
    meta: { title: 'Support Center' },
  },
  // Install page for Storyblok Apps
  {
    name: 'AppInstallPage',
    path: '/install/:appName',
    component: () =>
      import('src/components/ContentManager/AppInstallPage/index.vue'),
    meta: { title: 'App Install' },
  },
  // Shortcut to edit a story
  {
    name: 'EditStoryRoute',
    path: '/edit/:storyId',
    component: () =>
      import('src/components/ContentManager/EditStoryLink/index.vue'),
    meta: { isOutsideApp: true, keepRoute: true, title: 'Edit Story' },
  },
  {
    name: 'BuildSpaceRoute',
    path: '/build/:spaceId',
    component: () =>
      import('src/components/ContentManager/BuildSpacePage/index.vue'),
    query: { isOrg: false, isOnboarding: false, isDev: false },
    meta: { title: 'Build Space' },
  },
  {
    name: onboardingRouteName,
    path: '/onboarding',
    component: () =>
      import('src/components/ContentManager/OnboardingPage/index.vue'),
    meta: { title: 'Onboarding' },
  },
  {
    name: 'GetStartedRoute',
    path: '/get-started',
    component: () =>
      import('src/components/ContentManager/GetStartedPage/GetStartedPage.vue'),
    meta: { title: 'Get Started' },
  },
  {
    name: 'NewBlueprintSpaceRoute',
    path: '/spaces/new/blueprint',
    component: () =>
      import('src/components/ContentManager/BlueprintSpaceSetup/index.vue'),
    meta: { title: 'Blueprint' },
  },
]

export default routes
